// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1G-MV","basket":"style_basket__2sQVT","description":"style_description__A--63"};